export enum ExecutionProofType {
  NURSING = 'NURSING',
  MEDICATION = 'MEDICATION',
  FIXATION = 'FIXATION',
}
